import React, { useEffect, useState } from "reactn";
import { Table, Space, Button, Popconfirm, Row} from 'antd';
import { Link } from 'react-router-dom';
import firebaseDb from '../firebase';
import { doc, collection, getDocs, deleteDoc, query, where } from 'firebase/firestore';
import { EditOutlined, DeleteOutlined, Loading3QuartersOutlined, CheckOutlined, CloseOutlined, LeftOutlined } from "@ant-design/icons";

const Admins = (props) => {
    let [data, setData] = useState([]);
    let [totalCount, setTotalCount] = useState(0)
    let [loading, setLoading] = useState(false);

    let handleTableChange = async () => {
        get();
    }

    let get = async () => {
        const adminRef = collection(firebaseDb, 'users');
        const adminQuery = query(adminRef, where("role", "==", "admin"));
        const adminSnapshot = await getDocs(adminQuery);
        const adminList = adminSnapshot.docs.map((doc) => {
            doc.data().active = doc.data().active ? <CheckOutlined /> : <CloseOutlined />;
            return {
                id: doc.id,
                ...doc.data(),
                active: (doc.data().active ? <CheckOutlined /> : <CloseOutlined />),
                iscoderequired: (doc.data().required ? <CheckOutlined /> : <CloseOutlined />)
            }
        });
        setLoading(false)
        setTotalCount(adminList.length);
        setData(adminList);
    }

    useEffect(() => {
        setLoading(true)
        get();
    }, [])

    let columns = [
        {
            title: 'Fotograf',
            dataIndex: 'profileImageUrl',
            key: 'profileImageUrl',
            width: 100,
            render: (profileImageUrl, record) => {
                return (
                    <div style={{ width: '100px' }}>
                        <img src={profileImageUrl ? profileImageUrl : ""} style={{ width: '100%' }} />
                    </div>
                )
            }
        },
        {
            title: 'Adı',
            dataIndex: 'name',
            key: 'name',
            width: 50,

        },
        {
            title: 'Soyadı',
            dataIndex: 'surname',
            key: 'surname',
            width: 50,

        },
        {
            title: 'email',
            dataIndex: 'email',
            key: 'email',
            width: 100,

        },
        {
            title: '',
            key: 'action',
            fixed: 'right',
            align: 'right',
            className: 'editColumn',
            width: 50,
            render: (text, record) => (
                <Row size="small">
                    <Link to={"/admin/edit/" + record.id}>
                        <Button className="button-consultant" icon={<EditOutlined />}>Düzenle</Button>
                    </Link>
                </Row>
            ),
        },
    ];

    return (
        <div>
            <div className="list-head">
                <div className="list-title">
                    <h1>{"Adminler"} </h1>
                </div>
                <div className="list-buttons div-buttons">
                    <Link to="/adminInfo">
                        <Button className="button4" type="light" icon={<LeftOutlined />} size="large">GERİ</Button>
                    </Link>
                </div>
            </div>
            <div className="table-wrap">
                <Table dataSource={data} columns={columns} loading={{ spinning: loading, indicator: <Loading3QuartersOutlined spin />, size: "large" }}
                    onChange={handleTableChange}
                    pagination={{
                        total: totalCount
                    }}
                />
            </div>
        </div>
    );
};

export default Admins;
